module.exports = __webpack_public_path__ + "img/circle-g.19868cbb.svg";